import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  public selectedLanguage: any= 'fr'; // Default language is English
  public selectedApplication: any = null; // Application sélectionnée

  public statistics = [
    {
      label: 'Members',
      entity: 'User',
      bg: 'info',
      icon: 'cil-running',
      count: 0,
      url: '/members',
    }, {
      label: 'Competitions',
      entity: 'Competition',
      bg: 'warning',
      icon: 'sli-event',
      count: 0,
      url: '/competition',
    }, {
      label: 'Gifts',
      entity: 'Gift',
      bg: 'purple',
      icon: 'sli-calendar',
      count: 0,
      url: '/gifts',
    }, {
      label: 'Categories',
      entity: 'Category',
      bg: 'danger',
      icon: 'sli-film',
      count: 0,
      url: '/categories',
    },
    {
      label: 'DASHBOARD.Articles',
      entity: 'Article',
      bg: 'indigo',
      icon: 'cil-newspaper',
      count: 0,
      url: '/articles',
    },
    // {
    //   label: 'Events',
    //   entity: 'Event',
    //   bg: 'indigo',
    //   icon: 'cil-newspaper',
    //   count: 0,
    //   url: '/events',
    // },
    {
      label: 'APPLICATIONS',
      entity: 'Application',
      bg: 'indigo',
      icon: 'cil-newspaper',
      count: 0,
      url: '/applications',
    },
  
    {
      label: 'Videos et Podcast',
      entity: 'Video',
      bg: 'success',
      icon: 'sli-film',
      count: 0,
      url: '/videos',
    }
  ];

  constructor(
    private dashboardService: DashboardService,
    private titleService: Title,
    private translate: TranslateService

  ) {
  }

  ngOnInit(): void {
    let jsonAuth = localStorage.getItem(AuthService.ATUH_STORAGE_KEY);
  
    if (jsonAuth !== null) {
      const data = JSON.parse(jsonAuth);
      this.selectedApplication = data.application[0].id;
    }
  
    const locale = localStorage.getItem('locale');
    if (!locale) {
      localStorage.setItem('locale', this.selectedLanguage);
      this.translate.setDefaultLang(this.selectedLanguage);
      this.translate.use(this.selectedLanguage);
    }
  
    this.titleService.setTitle('Dashboard - Management');
  
    // 👇 Filtrage des statistiques selon selectedApplication
    const applicationId = Number(this.selectedApplication);
    if (applicationId === 2) {
      // Application 2 => inclut aussi Events
      this.statistics.push({
        label: 'Events',
        entity: 'Event',
        bg: 'indigo',
        icon: 'cil-newspaper',
        count: 0,
        url: '/events',
      });
       this.statistics.push({
        label: 'Notifications',
        entity: 'Notification',
        bg: 'indigo',
        icon: 'cil-newspaper',
        count: 0,
        url: '/notifications',
      });
      this.statistics = this.statistics.filter(stat =>
        ['Members', 'Competitions', 'Gifts', 'Categories', 'Events', 'Notifications'].includes(stat.label)
      );
    } else if (applicationId !== 7) {
      // Toutes les autres sauf 7
      this.statistics = this.statistics.filter(stat =>
        ['Members', 'Competitions', 'Gifts', 'Categories'].includes(stat.label)
      );
    }
    
  
    this.dashboardService.countTotalData().subscribe((response: any) => {
      console.log('response.success', response);
      this.statistics.forEach(stat => {
        switch (stat.entity) {
          case 'User':
            stat.count = response.success.users;
            break;
          case 'Competition':
            stat.count = response.success.competitions;
            break;
          case 'Gift':
            stat.count = response.success.gifts;
            break;
          case 'Category':
            stat.count = response.success.categories;
            break;
          case 'Article':
            stat.count = response.success.articles;
            break;
          case 'Application':
            stat.count = response.success.applications;
            break;
        }
      });
    });
  }
  

}
